<template>
	<div class="comp-record-sd-content" v-if="fans.id !== undefined">
		<div class="comp-record-sdc-title">
			<div class="comp-record-sdct-info">{{msgList.length}}条与“{{this.keyword}}”相关的聊天记录</div>
			<div class="comp-record-sdct-chat" @click="goChat">
				<span class="comp-record-sdctt-icon"></span>
				<span>进入聊天</span>
			</div>
		</div>
		<div class="comp-record-sdc-box">
			<div class="comp-record-sdc-items">
				<div class="comp-record-sdc-item" v-for="msg in msgList">
					<div class="comp-record-sdc-avatar">
						<img :src="msg.fans_photo" alt="" v-if="msg.is_me === 0">
						<img :src="msg.custom_photo | connectHost" alt="" v-else>
					</div>
					<div class="comp-record-sdc-info">
						<div class="comp-record-sdci-title">
							<span v-if="msg.is_me === 0">{{msg.fans_name}}</span>
							<span v-else>{{msg.cusotm_name}}</span>
							<span>{{msg.send_time}}</span>
						</div>
						<div class="comp-record-sdci-msg">
							<div class="comp-record-sdcim-detail" v-html="$options.filters.formatMsg(msg.content,msg.type)"></div>
							<div class="comp-record-sdcim-more" @click="findMore(msg)"><span>查看上下文</span></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getRecordListByFansAndkeyword
	} from '../../network/local/search.js'
	import {getCustomById} from '../../network/local/custom.js'

	export default {
		name: "ChatRecodSearchContentComp",
		props: {
			keyword: {
				type: String,
				default: ''
			},
			fans: {
				type: Object,
				default: function() {
					return {}
				}
			}
		},
		data() {
			return {
				msgList: []
			}
		},
		methods: {
			// 根据粉丝id，聊天记录内容，获取对应的聊天记录信息
			getRecord() {
				getRecordListByFansAndkeyword(this.fans.id, this.keyword, data => {
					let msgList = []
					let reg = new RegExp(this.keyword,'g')
					for (let i = 0; i < data.length; i++) {
						let msg = data[i]
						if(msg.type === 'text'){
							msg.content = msg.content.replace(reg,'<span style="color: #07d017">'+this.keyword+'</span>')
						}
						msgList.push(msg)
					}
					this.msgList = msgList
				})
			},

			// 进入聊天
			goChat() {
				if(this.fans.custom_id !== undefined){
					getCustomById(this.fans.custom_id,custom=>{
						let emitData = {
							id: this.fans.id,
							account_open_id:custom.open_id,
							friends_open_id: this.fans.open_id,
							friend_or_cluster_id:this.fans.id,
							friend_img: this.fans.wx_photo,
							friend_name:this.fans.wx_name,
							chat_type: 1
						}
						this.$emit('chat-click',emitData)
					})
				}
			},
			
			// 查看上下文
			findMore(msg){
				this.$emit('record-click',msg.id)
			}
		},
		watch: {
			fans(nVal) {
				this.getRecord()
			}
		}
	}
</script>

<style>
	.comp-record-sd-content {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 221px;
		overflow: hidden;
		color: #999999;
	}

	.comp-record-sd-content .comp-record-sdc-title {
		height: 30px;
		line-height: 30px;
		padding: 5px 20px;
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #e4e4e4;
	}

	.comp-record-sdc-title .comp-record-sdct-chat {
		color: #000000;
		cursor: pointer;
	}

	.comp-record-sdct-chat span {
		display: inline-block;
		vertical-align: middle;
	}

	.comp-record-sdct-chat .comp-record-sdctt-icon {
		width: 30px;
		height: 30px;
		background-image: url(../../assets/img/nav-chat-acitve.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 20px auto;
	}

	.comp-record-sdc-box {
		position: absolute;
		top: 41px;
		right: 0;
		bottom: 0;
		left: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.comp-record-sdc-box .comp-record-sdc-items {
		height: auto;
		padding: 0 20px;
		font-size: 12px;
	}

	.comp-record-sdc-items .comp-record-sdc-item {
		padding: 10px 0;
		overflow: hidden;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		border-bottom: 1px solid #e6e6e6;
	}

	.comp-record-sdc-item .comp-record-sdc-avatar {
		width: 36px;
		height: 36px;
		margin-right: 10px;
	}

	.comp-record-sdc-avatar img {
		width: 100%;
		height: 100%;
		border-radius: 4px;
	}

	.comp-record-sdc-item .comp-record-sdc-info {
		flex-grow: 1;
		width: 0;
		height: auto;
		overflow: hidden;
	}

	.comp-record-sdc-info .comp-record-sdci-title {
		height: 18px;
		line-height: 18px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.comp-record-sdc-info .comp-record-sdci-msg {
		margin-top: 5px;
		line-height: 18px;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}

	.comp-record-sdci-msg .comp-record-sdcim-detail {
		flex-grow: 1;
		width: 0;
		overflow: hidden;
		word-break: break-word;
		color: #333333;
		line-height: 20px;
	}
	.comp-record-sdcim-detail > .chat-program{
		border: 1px solid #e2e2e2;
		border-radius: 4px;
	}
	
	.comp-record-sdci-msg .comp-record-sdcim-more {
		width: 80px;
		color: #257ebd;
		cursor: pointer;
		text-align: right;
	}

	.comp-record-sdcim-more span {
		display: none;
	}

	.comp-record-sdc-item:hover .comp-record-sdcim-more>span {
		display: block;
	}
</style>
